import { format, getYear } from 'date-fns'

import { captureMessage } from '@sentry/nextjs'

import type { Tick, TimeUnit } from 'chart.js'

export const formatTimeTick = (
  timeUnit: TimeUnit | undefined,
  value: number | string,
  index: number,
  values: Tick[],
) => {
  // Chart.js types the value returned for time scales as `number | string`,
  // but in practice, it consistently returns a timestamp (number) for time scales.
  if (typeof value === 'string') {
    captureMessage('Unexpected string value in time tick')
    return value
  }

  switch (timeUnit) {
    case 'month': {
      // Remove the year from the tick label if the year is the same as the previous tick
      if (
        index > 0 &&
        getYear(values[index - 1].value) === getYear(values[index].value)
      ) {
        return format(value, 'MMM')
      }

      return format(value, 'MMM yyyy')
    }
    // @TODO: Add more cases as needed
    default:
      return value
  }
}
